
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DPill',
  props: {
    icon: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'current'
    },
    label: {
      type: String,
      default: ''
    }
  }
})
